export enum InputSize {
  XLARGE = 421,
  LARGE = 337,
  MIDDLE = 300,
  SMALL = 228,
  XSMALL = 108,
}
